import React from "react";
import { Collapse, Empty, List, Tag } from "antd";
import { FilePdfOutlined } from "@ant-design/icons";
import { useQuery } from "@apollo/client";
import CircularProgress from "../../CircularProgress";
import GQLAlertErrors from "../../GQLAlertErrors";
import { GQL_OSSERVATORIO_TARI_DOCS } from "../../../apollo/query/osservatorio-tari";
import MEFTariffeValidita from "./tariffe-validita";

const RUOLO_LABEL = {
   principale: "Delibera",
   allegato: "Allegato",
   testo_regolamento: "Regolamento",
};

const tariffeDescription = (tariffe) => {
   if (!tariffe) {
      return null;
   }
   const parts = [];
   if (tariffe.domestiche) {
      parts.push(
         `Domestiche (pag. ${(tariffe.pagine_domestiche ?? []).join(", ")})`
      );
   }
   if (tariffe.non_domestiche) {
      parts.push(
         `Non domestiche (pag. ${(tariffe.pagine_non_domestiche ?? []).join(", ")})`
      );
   }
   return parts.length ? `Tariffe: ${parts.join(" - ")}` : null;
};

const MEFDocs = ({ comuneCode }) => {
   const { data, loading, error } = useQuery(GQL_OSSERVATORIO_TARI_DOCS, {
      variables: { comune_code_istat: comuneCode },
      //gli url dei documenti sono temporanei: non riusare la cache
      fetchPolicy: "network-only",
   });

   if (loading) {
      return <CircularProgress />;
   }

   if (error) {
      return <GQLAlertErrors error={error} />;
   }

   const anni = [...(data?.osservatorioTariDocs?.anni ?? [])].sort(
      (a, b) => b.anno - a.anno
   );

   if (!anni.length) {
      return <Empty />;
   }

   return (
      <Collapse defaultActiveKey={[anni[0].anno]}>
         {anni.map(({ anno, documenti }) => (
            <Collapse.Panel key={anno} header={anno}>
               <MEFTariffeValidita comuneCode={comuneCode} anno={anno} />
               <List
                  size="small"
                  dataSource={documenti}
                  renderItem={(doc) => (
                     <List.Item>
                        <List.Item.Meta
                           avatar={<FilePdfOutlined />}
                           title={
                              <>
                                 <a
                                    href={doc.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ textDecoration: "underline" }}
                                 >
                                    {doc.nome}
                                 </a>
                                 {doc.ruolo && (
                                    <Tag className="gx-ml-2">
                                       {RUOLO_LABEL[doc.ruolo] ?? doc.ruolo}
                                       {doc.numero_allegato &&
                                          ` ${doc.numero_allegato}`}
                                    </Tag>
                                 )}
                              </>
                           }
                           description={tariffeDescription(doc.tariffe)}
                        />
                     </List.Item>
                  )}
               />
            </Collapse.Panel>
         ))}
      </Collapse>
   );
};

export default MEFDocs;
